import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import '../serviceStripping/StrippingTop.css'

const StrippingTop = () => {
    const [selectedAddService, setSelectedAddService] = useState("Public");
  return (
    <div className='strippingTop-main-sec pb-4'> 
        <div className='strippingTop-sec'>
            <div className='strippingTop-box mb-md-4 mb-3'>
                <div className='border-box-top d-flex flex-wrap align-items-center justify-content-between'>
                    <div className='text-box'>
                        <h2>Discount Entire Category</h2>
                    </div>
                    <div className='right-details'>
                        <ul className='d-flex flex-wrap align-items-center gap-md-3 gap-1'>
                            <li className='deactive-box'>%0</li>
                            <li className='active-box'>Apply</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className='strippingTop-service'>
                <div className='bottom-add-service d-flex flex-wrap '>
                    <div className='left-add-service'>
                        <div className="top-add mb-3">
                            <Link rel='stylesheet' className='default-btn d-flex align-items-center gap-3' to="/" > 
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5254 6.80713V16.0379" stroke="#FD59D9" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.90918 11.4224H15.1399" stroke="#FD59D9" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.91 1.42236H5.14078C2.59178 1.42236 0.525391 3.48875 0.525391 6.03775V16.807C0.525391 19.3561 2.59178 21.4224 5.14078 21.4224H15.91C18.4591 21.4224 20.5254 19.3561 20.5254 16.807V6.03775C20.5254 3.48875 18.4591 1.42236 15.91 1.42236Z" stroke="#FD59D9" stroke-linecap="round" stroke-linejoin="round"/></svg> Add Service
                            </Link>
                        </div>
                        <div className='bottom-form-box'>
                            <form action="">
                                <div className='form-group first-input'>
                                    <input type="text" className="form-control" id="" placeholder="Name" />
                                </div>
                                <div className='form-group price-input'>
                                    <input type="text" className="form-control" id="" placeholder="$0.00" />
                                </div>
                                <div className="form-group">
                                    <div className="form-box">
                                        <textarea name="" rows="5" cols="40" id="" placeholder='Description'></textarea>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className='right-add-service'>
                        <div className='inner-right-box d-flex flex-column h-100'>
                            <div className='top-btn'>
                                <div className='filter-box mb-md-4 mb-3'>
                                    <ul className='radio-box-checked'>
                                        <li>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="AddService" id="Public" value="Public" checked={selectedAddService==="Public" } onChange={()=> setSelectedAddService("Public")} />
                                                <label className="form-check-label" htmlFor="Public">Public</label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio" name="AddService" id="Subscription" value="Subscription" checked={selectedAddService==="Subscription" } onChange={()=> setSelectedAddService("Subscription")} />
                                                <label className="form-check-label" htmlFor="Subscription">Subscription</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <Link rel='stylesheet' className='btn btn-border active-btn mt-auto'>Post</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default StrippingTop
